import React, { createContext, useContext, useState, useEffect } from 'react';
import { getImagesCompanies } from '../services/companiesService'; 
import { useAuth } from './authContext';
const ImagesContext = createContext();

export const ImagesProvider = ({ children }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const [hasFetched, setHasFetched] = useState(false);

  const optimizeCloudinaryUrl = (url) => {
    if (!url.includes('/upload/')) return url;
    return url.replace('/upload/', '/upload/f_auto,q_auto/');
  };
  
  const isValidUrl = (url) => {
    return url != null && url.startsWith('http');
  };

  
  // Función para cargar las imágenes
  const fetchImages = async () => {
    try {
      setLoading(true);
      const response = await getImagesCompanies(user); // Tu función ya creada
      console.log('Respuesta API logos:', response);
      setImages(
        response.data
          .filter(company => isValidUrl(company.logo)) // Solo las que tienen un URL válido
          .map(company => ({
            business_name: company.businessName,
            logo_url: optimizeCloudinaryUrl(company.logo),
          }))
      );
    } catch (error) {
      console.error('Error cargando logos del carrusel:', error);
    } finally {
      setLoading(false);
    }
  };

  // Cargar imágenes al montar
  useEffect(() => {
    if (!hasFetched) {
      fetchImages();
      setHasFetched(true);
    }
  }, [hasFetched]);

  // Función pública para refrescar imágenes manualmente (por ejemplo si un usuario cambia su logo)
  const refreshImages = async () => {
    await fetchImages();
  };

  return (
    <ImagesContext.Provider value={{ images, loading, refreshImages }}>
      {children}
    </ImagesContext.Provider>
  );
};

// Hook para usar el contexto fácilmente
export const useImages = () => useContext(ImagesContext);
